var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Popconfirm',{attrs:{"cancel-text":_vm.$t('Ne'),"ok-text":_vm.$t('Da'),"title":_vm.$t('Jeste li sigurni?')},on:{"confirm":function($event){return _vm.$emit('confirm')}}},[_c('Icon',{staticClass:"confirmIcon",attrs:{"slot":"icon","theme":"filled","type":"exclamation-circle"},slot:"icon"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }